/*
 Copyright 2026 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the
 project root for license information.
*/

/**
 * Gallery API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SourceType = 'News' | 'Social' | 'Email' | 'Phone' | 'Intel' | 'Reporting' | 'Orders';

export const SourceType = {
    News: 'News' as SourceType,
    Social: 'Social' as SourceType,
    Email: 'Email' as SourceType,
    Phone: 'Phone' as SourceType,
    Intel: 'Intel' as SourceType,
    Reporting: 'Reporting' as SourceType,
    Orders: 'Orders' as SourceType
};

